export default "__VITE_ASSET__Cuh98UPl__"